// @ts-nocheck
import React, {
  useRef,
  useState,
  useEffect,
  useContext,
  useCallback,
} from 'react';
import { inject, observer } from 'mobx-react';
import { url as imageUrl } from 'utils/image';
import { ThemeContext } from 'store/ThemeProvider';

import request from '../../utils/request';
import ComponentLink from '../ComponentLink';
import RootStore from '../../store/RootStore';

import './index.scss';

export interface IExhibitorItem {
  id: number;
  order_id: number;
  name: string;
  short_name: string;
  booth: string;
  desc: string;
  contact_person: string;
  contact_person_mobile: string;
  gallery_id: number;
  gallery_pagedata_id: number;
  exhibitor_logo: string | null;
  status: number;
  gallerys_detail?: any;
  gallerys_pagedata_detail?: any;
}

export interface IComponentExhibitor {
  cid: string;
  list?: IExhibitorItem[];
  search?: boolean;
  showList?: boolean;
  autoShowAll?: boolean;
  banner?: string;
  exhibitorOrder?: number[];
  container?: any;
  rootStore?: RootStore;
  showPhotoCount?: boolean;
  showBooth?: boolean;
}

const PAGE_SIZE = 10;
const BOTTOM_THRESHOLD = 20;


export const searchSvg = (<svg t="1772606931184" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4774" width="200" height="200"><path d="M446.112323 177.545051c137.567677 0.219798 252.612525 104.59798 266.162424 241.493333 13.562828 136.895354-78.778182 261.818182-213.617777 289.008485-134.852525 27.203232-268.386263-52.156768-308.945455-183.608889s25.018182-272.252121 151.738182-325.779394A267.235556 267.235556 0 0 1 446.112323 177.545051m0-62.060607c-182.794343 0-330.989899 148.195556-330.989899 330.989899s148.195556 330.989899 330.989899 330.989899 330.989899-148.195556 330.989899-330.989899-148.195556-330.989899-330.989899-330.989899z m431.321212 793.341415a30.849293 30.849293 0 0 1-21.94101-9.102223l-157.220202-157.220202c-11.752727-12.179394-11.584646-31.534545 0.37495-43.50707 11.972525-11.972525 31.327677-12.140606 43.494141-0.37495l157.220202 157.220202a31.036768 31.036768 0 0 1 6.723232 33.810101 31.004444 31.004444 0 0 1-28.651313 19.174142z m0 0" p-id="4775"></path></svg>);


const ExhibitorItem: React.FC<{
  item: IExhibitorItem;
  onClick: (item: IExhibitorItem) => void;
  h1Color: string;
  h2Color: string;
  mainColor: string;
  showPhotoCount?: boolean;
  showBooth?: boolean;
}> = ({ item, onClick, h1Color, h2Color, mainColor, showPhotoCount = false, showBooth = true }) => {

  const exhibitorLogo = item.exhibitor_logo || 'attachment/5b2f8d7a8532a8657f832b8fb8c85e55.png';

  const logoSrc = imageUrl(exhibitorLogo, {
    'x-oss-process':
      'image/resize,m_pad,w_400,h_400,color_ffffff/format,jpg',
  }, 1);

  const showMeta = showPhotoCount || showBooth;
  const photoCount = (item as any).gallerys_detail?.img_count;

  return (
    <div className="exhibitor-item" onClick={() => onClick(item)}>
      <div
        className="exhibitor-logo"
        style={logoSrc ? undefined : { background: mainColor || '#24d9cd' }}
      >
        {logoSrc ? (
          <img src={logoSrc} alt={item.name} />
        ) : (
          <span className="logo-placeholder">展</span>
        )}
      </div>
      <div
        className="exhibitor-info"
        style={!showMeta ? { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } : undefined}
      >
        <div className="exhibitor-name" style={{ color: h1Color }}>
          {item.name || item.short_name || '未命名展商'}
        </div>
        {showMeta && (
          <div className="exhibitor-booth" style={{ color: h2Color }}>
            {showPhotoCount && photoCount != null && (
              <span style={{ marginRight: showBooth ? 8 : 0 }}>照片:{photoCount}</span>
            )}
            {showBooth && <span>展位：{item.booth || '-'}</span>}
          </div>
        )}
      </div>
      <div className="exhibitor-arrow">
        <svg viewBox="0 0 24 24" width="16" height="16">
          <path
            fill={h2Color}
            d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"
          />
        </svg>
      </div>
    </div>
  );
};

/**
 * 请求展商列表接口
 */
const fetchExhibitorList = async (params: {
  order_id: string;
  page?: number;
  page_size?: number;
  name?: string;
  ids?: string;
  gallery_id?: string;
}) => {
  const data: any = {
    _with: 'gallerys_detail',
    page: params.page || 1,
    page_size: params.page_size || PAGE_SIZE,
    order_id: params.order_id,
    status: 1,
    //  !null=gallery_id
    "!null": 'gallery_id',
  };
  if (params.name) {
    data.name = params.name;
  }
  if (params.ids) {
    data.ids = params.ids;
    data.page_size = params.ids.split(',').length;
  }
  if (params.gallery_id) {
    data.gallery_id = params.gallery_id;
  }
  return request({
    url: `/api/v2/exhibitor/list`,
    method: 'GET',
    data,
  });
};

const AllForExhibitor: React.FC<IComponentExhibitor> = (props) => {
  const {
    list = [],
    search = true,
    showList = true,
    autoShowAll = false,
    exhibitorOrder = [],
    showPhotoCount = false,
    showBooth = true,
  } = props;

  const [exhibitors, setExhibitors] = useState<IExhibitorItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  // 搜索触发时是否已搜索过（控制 showList=false 时的列表显示）
  const [hasSearched, setHasSearched] = useState(false);

  const exhibitorsRef = useRef<IExhibitorItem[]>([]);
  const pageRef = useRef(1);
  const appendLoadingRef = useRef(false);
  const hasMoreRef = useRef(true);
  const keywordRef = useRef('');
  const pendingLoadMoreRef = useRef(false);
  const scrollContainerRef = useRef<HTMLElement | null>(null);
  const scrollRafIdRef = useRef<number | null>(null);

  const setHasMoreSafe = useCallback((nextHasMore: boolean) => {
    hasMoreRef.current = nextHasMore;
    setHasMore(nextHasMore);
  }, []);

  const resolveScrollContainer = useCallback(() => {
    const target =
      (document.querySelector('.decorate-container') as HTMLElement | null) ||
      (document.scrollingElement as HTMLElement | null) ||
      document.documentElement ||
      document.body;

    scrollContainerRef.current = target;
    return target;
  }, []);

  const getViewportHeight = useCallback((element: HTMLElement | null) => {
    if (!element) return window.innerHeight || 0;

    if (
      element === document.documentElement ||
      element === document.body ||
      element === document.scrollingElement
    ) {
      return window.innerHeight || element.clientHeight || 0;
    }

    return element.clientHeight || window.innerHeight || 0;
  }, []);

  useEffect(() => {
    exhibitorsRef.current = exhibitors;
  }, [exhibitors]);

  useEffect(()=>{
    exhibitorsRef.current = [];
  }, [search]);

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    hasMoreRef.current = hasMore;
  }, [hasMore]);

  useEffect(() => {
    keywordRef.current = keyword;
  }, [keyword]);

  const { h1Color, h2Color, mainColor, componentColor } =
    useContext(ThemeContext);

  const orderId = window.gallery?.orderid;

  const isPageNearBottom = useCallback(() => {
    const scrollingElement = resolveScrollContainer();
    const scrollTop = scrollingElement?.scrollTop || 0;
    const viewportHeight = getViewportHeight(scrollingElement);
    const pageHeight = scrollingElement?.scrollHeight || 0;

    if (scrollTop <= 0 || pageHeight <= 0) {
      return false;
    }

    return scrollTop + viewportHeight >= pageHeight - BOTTOM_THRESHOLD;
  }, [getViewportHeight, resolveScrollContainer]);

  /**
   * 加载展商列表（支持分页追加）
   */
  const loadExhibitors = useCallback(
    async (pageNum: number, searchKeyword: string, append: boolean = false) => {
      if (append && appendLoadingRef.current) {
        return;
      }

      if (!append) {
        pendingLoadMoreRef.current = false;
      }

      if (!orderId) {
        setExhibitors([]);
        setTotal(0);
        setHasMoreSafe(false);
        return;
      }

      if (append) {
        appendLoadingRef.current = true;
      }

      setLoading(true);
      try {
        const res = await fetchExhibitorList({
          order_id: orderId,
          page: pageNum,
          page_size: PAGE_SIZE,
          name: searchKeyword || undefined,
        });
        if (res.code === 200 && res.data?.items) {
          let items = res.data.items.filter(
            (it: IExhibitorItem) => it.status === 1
          );
          const totalCount = res.data.total || 0;

          // 按照片数倒序排列（照片数多的排前面）
          if (!searchKeyword) {
            items = items.sort((a: IExhibitorItem, b: IExhibitorItem) => {
              const aCount = (a as any).gallerys_detail?.img_count || 0;
              const bCount = (b as any).gallerys_detail?.img_count || 0;
              return bCount - aCount;
            });
          }

          // 通过函数式回调捕获真实的 prevLength，避免 exhibitorsRef 异步更新导致的陈旧值
          let prevLength = 0;
          if (append) {
            setExhibitors((prev) => {
              prevLength = prev.length;
              return [...prev, ...items];
            });
          } else {
            prevLength = 0;
            setExhibitors(items);
          }

          setTotal(totalCount);
          setPage(pageNum);
          pageRef.current = pageNum;
          const loadedCount = append
            ? prevLength + items.length
            : items.length;
          const nextHasMore = items.length > 0 && loadedCount < totalCount;
          setHasMoreSafe(nextHasMore);
        } else {
          if (!append) setExhibitors([]);
          setHasMoreSafe(false);
        }
      } catch (e) {
        console.error('获取展商列表失败', e);
        if (!append) setExhibitors([]);
        setHasMoreSafe(false);
      } finally {
        if (append) {
          appendLoadingRef.current = false;

          if (pendingLoadMoreRef.current) {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                pendingLoadMoreRef.current = false;

                if (hasMoreRef.current && isPageNearBottom()) {
                  loadExhibitors(pageRef.current + 1, keywordRef.current, true);
                }
              });
            });
          }
        }
        setLoading(false);
      }
    },
    [orderId, isPageNearBottom, setHasMoreSafe]
  );

  /**
   * 加载手动模式下通过 IDs 反查的展商
   */
  const loadExhibitorsByIds = useCallback(async () => {
    if (!list || list.length === 0 || !orderId) {
      setExhibitors([]);
      return;
    }
    setLoading(true);
    try {
      const ids = list.map((it: any) => it.id).join(',');
      const res = await fetchExhibitorList({
        order_id: orderId,
        ids,
      });
      if (res.code === 200 && res.data?.items) {
        const itemsMap: Record<number, IExhibitorItem> = {};
        res.data.items.forEach((item: IExhibitorItem) => {
          itemsMap[item.id] = item;
        });
        const orderedItems = list
          .map((it: any) => itemsMap[it.id])
          .filter((it: any) => !!it);
        setExhibitors(orderedItems);
        setTotal(orderedItems.length);
        setHasMoreSafe(false);
      } else {
        setExhibitors([]);
        setTotal(0);
        setHasMoreSafe(false);
      }
    } catch (e) {
      console.error('获取展商列表失败', e);
      setExhibitors([]);
      setTotal(0);
      setHasMoreSafe(false);
    } finally {
      setLoading(false);
    }
  }, [list, orderId, setHasMoreSafe]);

  // 初始化加载
  useEffect(() => {
    if (autoShowAll) {
      // 自动模式：从后端分页获取
      loadExhibitors(1, '');
    } else if (list && list.length > 0) {
      // 手动模式：根据 IDs 反查
      const hasFullData = list.some((it: any) => it.name || it.short_name);
      if (hasFullData) {
        setExhibitors(list);
        setTotal(list.length);
        setHasMoreSafe(false);
      } else {
        loadExhibitorsByIds();
      }
    } else {
      setExhibitors([]);
      setTotal(0);
      setHasMoreSafe(false);
    }
  }, [autoShowAll, list, exhibitorOrder, loadExhibitors, loadExhibitorsByIds, setHasMoreSafe]);

  /**
   * 搜索
   */
  const onSearch = (value: string) => {
    setKeyword(value);
    keywordRef.current = value;
    pendingLoadMoreRef.current = false;
    setHasSearched(true);

    if (autoShowAll) {
      // 自动模式：后端搜索
      loadExhibitors(1, value);
    } else {
      // 手动模式：如果有搜索词，走后端搜索；否则显示手动列表
      if (value) {
        loadExhibitors(1, value);
      } else {
        // 清空搜索时恢复原列表
        loadExhibitorsByIds();
        setHasSearched(false);
      }
    }
  };

  // showList 逻辑：
  // showList=true（默认）→ 始终显示列表
  // showList=false → 只显示搜索框，搜索后才显示结果
  const shouldShowList = showList || hasSearched;

  const requestLoadMore = useCallback(() => {
    if (!hasMoreRef.current) {
      return;
    }

    if (!isPageNearBottom()) {
      return;
    }

    if (appendLoadingRef.current) {
      pendingLoadMoreRef.current = true;
      return;
    }

    loadExhibitors(pageRef.current + 1, keywordRef.current, true);
  }, [isPageNearBottom, loadExhibitors]);

  /**
   * 页面滚动加载更多
   */
  const handlePageScroll = useCallback(() => {
    if (scrollRafIdRef.current != null) {
      return;
    }

    scrollRafIdRef.current = window.requestAnimationFrame(() => {
      scrollRafIdRef.current = null;
      requestLoadMore();
    });
  }, [requestLoadMore]);

  useEffect(() => {
    return () => {
      if (scrollRafIdRef.current != null) {
        window.cancelAnimationFrame(scrollRafIdRef.current);
        scrollRafIdRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!shouldShowList || exhibitors.length === 0 || !hasMore) {
      return;
    }

    const onWindowScroll = () => {
      handlePageScroll();
    };

    const scrollingElement = resolveScrollContainer();

    scrollingElement?.addEventListener('scroll', onWindowScroll, { passive: true });

    return () => {
      scrollingElement?.removeEventListener('scroll', onWindowScroll);
    };
  }, [shouldShowList, exhibitors.length, hasMore, handlePageScroll, resolveScrollContainer]);

  const onExhibitorClick = (item: IExhibitorItem) => {
    const url = `/page/exhibitor/${item.id}`;
    console.log('跳转展商详情页', url);
    ComponentLink.to(url);
  };

  return (
    <div
      className="component-exhibitor-list"
      style={{ backgroundColor: componentColor }}
    >
      {search && (
        <div className="exhibitor-search">
          <div className="exhibitor-search-input">
            <div
              className="search-icon-img"
              onClick={() => {
                const inputEl = document.querySelector('.exhibitor-search-input input') as HTMLInputElement;
                if (inputEl) onSearch(inputEl.value);
              }}
              style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              {React.cloneElement(searchSvg, { style: { width: '20px', height: '20px' } })}
            </div>
            <input
              placeholder="输入展商名、简称、展位号等关键词"
              onKeyDown={(e) => {
                if (e.key === 'Enter') onSearch((e.target as HTMLInputElement).value);
              }}
              onChange={(e) => {
                const val = e.target.value;
                if (!val) onSearch('');
              }}
            />
          </div>
        </div>
      )}

      {shouldShowList && (
        <div className="exhibitor-list">
          {exhibitors.length === 0 && !loading ? (
            <div className="exhibitor-empty" style={{ color: h2Color }}>
              {hasSearched ? '未找到相关展商' : '暂无展商信息'}
            </div>
          ) : (
            exhibitors.map((item) => (
              <ExhibitorItem
                key={item.id}
                item={item}
                onClick={onExhibitorClick}
                h1Color={h1Color}
                h2Color={h2Color}
                mainColor={mainColor}
                showPhotoCount={showPhotoCount}
                showBooth={showBooth}
              />
            ))
          )}

          {loading && (
            <div className="exhibitor-loading" style={{ color: h2Color }}>
              加载中...
            </div>
          )}

          {!hasMore && exhibitors.length > 0 && !loading && (
            <div className="exhibitor-bottom-tip" style={{ color: h2Color }}>
              共有 {total} 个展商
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default inject('rootStore')(observer(AllForExhibitor));
